export default [
    {
        path: 'proveedores',
        component: () => import('@/components/shared/proveedores/ProveedoresIndex.vue'),
        props: { baseRoute: 'pos' },
        children: [
            {
                path: '',
                name: 'pos.proveedores',
                component: () => import('@/components/shared/proveedores/ProveedoresList.vue'),
            },
            {
                path: 'nuevo',
                name: 'pos.proveedores.create',
                component: () => import('@/components/shared/proveedores/componentes/ProveedorCreate.vue'),
            },
            {
                path: 'listasdeprecio',
                name: 'pos.proveedores.listasdeprecio',
                component: () => import('@/views/pos/proveedores/listasDePrecios/ProveedoresListasDePrecios.vue'),
            },
        ]
    },

    {
        path: 'proveedores/:id_proveedor',
        component: () => import('@/components/shared/proveedores/ProveedorLayout.vue'),
        props: { baseRoute: 'pos' },
        children: [
            {
                path: '',
                name: 'pos.proveedor.profile',
                component: () => import('@/components/shared/proveedores/ProveedorProfile.vue'),
            },
            {
                path: 'editar',
                name: 'pos.proveedor.update',
                component: () => import('@/components/shared/proveedores/ProveedorUpdate.vue'),
            },
            {
                path: 'listadeprecios',
                name: 'pos.proveedor.listadeprecios',
                component: () => import('@/components/shared/proveedores/ProveedorListaDePrecio.vue'),
            },
            {
                path: 'cuenta-corriente',
                name: 'pos.proveedor.cuentacorriente',
                component: () => import('@/components/shared/proveedores/ProveedorCuentaCorriente.vue'),
            },
        ],
    },
]
